import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * profile sheared service
 */
@Injectable({
  providedIn: 'root',
})
export class ProfileSharedService {
  private profileSubject = new Subject<boolean>();

  profileUpdates$ = this.profileSubject.asObservable();

  triggerProfileUpdates(): void {
    this.profileSubject.next(true);
  }
}
